import { render, staticRenderFns } from "./scatteredorder.vue?vue&type=template&id=a7242ff2&scoped=true"
import script from "./scatteredorder.vue?vue&type=script&lang=ts"
export * from "./scatteredorder.vue?vue&type=script&lang=ts"
import style0 from "./scatteredorder.vue?vue&type=style&index=0&id=a7242ff2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7242ff2",
  null
  
)

export default component.exports